import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { PrivateAPI } from '../utils/api'

type TPurchaseUploadCreditsInput = {
  numberOfCredits: number
}

type TPurchaseUploadCreditsResponse = {
  clientSecret: string
  finalTotal: number
  orderId: string
  paymentIntentId: string
  shouldChargeVat: boolean
  subtotal: number
  vatTotal: number
}

const getPurchaseUploadCreditsErrorMessage = (err: unknown) => {
  const defaultMessage = 'An unexpected error occured'

  if (!axios.isAxiosError(err)) {
    return `${defaultMessage} [990]`
  }

  const status = err.response?.status

  if (!status) {
    return `${defaultMessage} [990]`
  }

  if (status >= 400 && status < 500) {
    return `${defaultMessage} [${status}]`
  }

  return defaultMessage
}

const usePurchaseUploadCredits = () => {
  return useMutation<
    TPurchaseUploadCreditsResponse,
    Error,
    TPurchaseUploadCreditsInput
  >({
    mutationKey: ['purchase-upload-credits'],
    mutationFn: async ({ numberOfCredits }) => {
      try {
        const response = await PrivateAPI<TPurchaseUploadCreditsResponse>({
          url: '/billing/upload/checkout',
          method: 'post',
          data: { numberOfCredits },
        })

        return response.data
      } catch (err) {
        throw new Error(getPurchaseUploadCreditsErrorMessage(err))
      }
    },
  })
}

export default usePurchaseUploadCredits
